import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Mission from '../components/Mission';
import Courses from '../components/Courses';
import BlogPreview from '../components/BlogPreview';
import Contact from '../components/Contact';

const HomePage = () => (
  <>
    <Hero />
    <About />
    <Mission />
    <Courses />
    <BlogPreview />
    <Contact />
  </>
);

export default HomePage;
